import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AccountFilterComponent } from '../../_shared/components/filters/account-filter/account-filter.component';
import { DriversInYardWidgetComponent } from './components/widgets/drivers-in-yard-widget/drivers-in-yard-widget.component';
import { DriversInVehicleWidgetComponent } from './components/widgets/drivers-in-vehicle-widget/drivers-in-vehicle-widget.component';
import { DriversEnRouteWidgetComponent } from './components/widgets/drivers-en-route-widget/drivers-en-route-widget.component';
import { StationaryDriversWidgetComponent } from './components/widgets/stationary-drivers-widget/stationary-drivers-widget.component';
import { DriverStatusTableComponent } from './components/driver-status-table/driver-status-table.component';
import { DashboardDriverMapComponent } from './components/dashboard-driver-map/dashboard-driver-map.component';
import { HighestOvertimeGraphComponent } from './components/graphs/highest-overtime-graph/highest-overtime-graph.component';
import { DriverUtilisationGraphComponent } from './components/graphs/driver-utilisation-graph/driver-utilisation-graph.component';
import { FrequentStopsGraphComponent } from './components/graphs/frequent-stops-graph/frequent-stops-graph.component';
import { AuthService, FilterService } from '../../_shared/services';
import { AccountFilterData, WidgetFilterData } from '../../_shared/models';
import { isEmptyObject } from '../../_shared/helpers/object.helper';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    RouterModule,
    NgbTooltipModule,
    AccountFilterComponent,
    DriversInYardWidgetComponent,
    DriversInVehicleWidgetComponent,
    DriversEnRouteWidgetComponent,
    StationaryDriversWidgetComponent,
    DriverStatusTableComponent,
    DashboardDriverMapComponent,
    HighestOvertimeGraphComponent,
    DriverUtilisationGraphComponent,
    FrequentStopsGraphComponent,
    TranslocoPipe
],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit, OnDestroy {
  private filterService = inject(FilterService);
  private auth = inject(AuthService);

  public accountFilter: AccountFilterData = {} as AccountFilterData;
  public isStatusTableLoading: boolean = false;

  private filterSubscription: Subscription | undefined;
  private refreshIntervalId: any;

  ngOnInit(): void {
    const refreshTime = this.auth.getUserSettings()?.dashboardRefreshTime;
    if (refreshTime) {
      this.startRefreshInterval(refreshTime);
    }
  }

  ngOnDestroy(): void {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }

  onLoadingChange(isLoading: boolean): void {
    this.isStatusTableLoading = isLoading;
  }

  private startRefreshInterval(seconds: number): void {
    this.refreshIntervalId = setInterval(() => {
      this.onAccountFilterChange(this.accountFilter);
    }, seconds * 1000);
  }

  onAccountFilterChange(filter: AccountFilterData): void {
    if (!isEmptyObject(filter)) {
      this.accountFilter = filter;
      this.updateFilter();
    }
  }

  private updateFilter(): void {
    if (!isEmptyObject(this.accountFilter)) {
      this.filterService.updateFilter({
        ...this.accountFilter
      } as WidgetFilterData);
    }
  }
}